/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {
    NbLoginComponent,
    NbAuthService,
    NB_AUTH_OPTIONS,
    NbAuthResult,
    getDeepFromObject,
    NbAuthModule,
    NbPasswordAuthStrategy,
    NbAuthJWTToken
} from '@nebular/auth';
import { PasswordAuthStrategySettings } from '../../../@core/core.module';

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss']
})
export class NgxResetPasswordComponent extends NbLoginComponent implements OnInit {
    redirectDelay: number = 0;
    showMessages: any = {};
    strategy: string = '';

    submitted = false;
    errors: string[] = [];
    messages: string[] = [];
    user: any = {};
    token: string;
    reference: number;
    disableCTA = false;

    constructor(
        private route: ActivatedRoute,
        protected service: NbAuthService,
        private authStrategy: NbPasswordAuthStrategy,
        @Inject(NB_AUTH_OPTIONS) protected options = {},
        protected cd: ChangeDetectorRef,
        protected router: Router
    ) {
        super(service, options, cd, router);

        this.redirectDelay = this.getConfigValue('forms.resetPassword.redirectDelay');
        this.showMessages = this.getConfigValue('forms.resetPassword.showMessages');
        this.strategy = this.getConfigValue('forms.resetPassword.strategy');
    }

    ngOnInit() {
        this.getParamsFromUrl();

        this.user.token = this.token;
        this.user.reference = this.reference;

        this.authStrategy.setOptions({
            ...PasswordAuthStrategySettings,
            resetPass: {
                endpoint: `/public/v1/password-reset/${this.user.reference}`,
                method: 'post'
            }
        });
    }

    getParamsFromUrl() {
        this.reference = this.route.snapshot.params.reference;
        this.token = this.route.snapshot.params.token;
    }

    resetPass(): void {
        this.errors = this.messages = [];
        this.submitted = true;

        this.service.resetPassword(this.strategy, this.user).subscribe((result: NbAuthResult) => {
            this.submitted = false;

            if (result.isSuccess()) {
                this.messages = result.getMessages();
                this.disableCTA = true;
            } else {
                this.errors = result.getErrors();
            }

            const redirect = result.getRedirect();
            if (redirect) {
                setTimeout(() => {
                    return this.router.navigateByUrl(redirect);
                }, this.redirectDelay);
            }
            this.cd.detectChanges();
        });
    }

    getConfigValue(key: string): any {
        return getDeepFromObject(this.options, key, null);
    }
}
